import { gql } from '@apollo/client'

export const CREATE_STATE = gql`
  mutation createState($input: CreateStateInput!) {
    data: createState(input: $input) {
      id
    }
  }
`
